import ZhCN from "./zh_CN/all";
import EnUS from "./en_US/all";

function getLang() {
  let lan = navigator.systemLanguage || navigator.language;
  if (lan.toLowerCase().indexOf("zh") !== -1) {
    return ZhCN;
  }
  return EnUS;
}

export function formatMessage(data) {
  const value = getLang();
  return value[data.id] || data.defaultMessage;
}



// WEBPACK FOOTER //
// ./src/locales/index.js